import { Stack, StackProps } from "@mui/material";
import { FC } from "react";

export const FormStack: FC<StackProps> = ({ direction, ...props }) => (
  <Stack spacing={direction === "row" ? 2 : 4} direction={direction} {...props} />
);
